import { IRoute, RoutePath } from "routers/config"
import { EUserRole, EVendorType } from "types"

export interface RoutePermissionCheck {
  role?: EUserRole
  vendorType?: EVendorType
  isShowChat?: boolean
}

export const hasRoutePermission = (
  route: IRoute,
  { role, vendorType, isShowChat }: RoutePermissionCheck
): boolean => {
  // Check if route requires specific roles
  if (route.showWithRoles && role) {
    const hasRole = route.showWithRoles.includes(role)
    if (!hasRole) {
      return false
    }
  }

  // Check if route should be hidden for specific vendor types
  if (route.hideWithVendorType && vendorType) {
    const shouldHide = route.hideWithVendorType.includes(vendorType)
    const chatOverride =
      shouldHide && route.showForBrandStoreIfChatEnabled && isShowChat
    if (shouldHide && !chatOverride) {
      return false
    }
  }

  // Check if route is force hidden
  if (route.forceHide) {
    return false
  }

  // Check if route should be in sidebar but user doesn't have access
  if (route.inSidebar && role) {
    const hasRole = route.showWithRoles
      ? route.showWithRoles.includes(role)
      : true
    const shouldHideForVendor =
      route.hideWithVendorType && vendorType
        ? route.hideWithVendorType.includes(vendorType)
        : false
    const chatOverride =
      shouldHideForVendor && route.showForBrandStoreIfChatEnabled && isShowChat

    if (!hasRole || (shouldHideForVendor && !chatOverride) || route.forceHide) {
      return false
    }
  }

  return true
}

export const getFallbackRoute = ({
  role,
  vendorType,
}: RoutePermissionCheck): string => {
  // BrandStore vendors should go to Pages
  if (vendorType === EVendorType.BrandStore) {
    return RoutePath.Pages
  }

  // Admin users can go to Orders
  if (role === EUserRole.Pom_Super_Admin) {
    return RoutePath.Orders
  }

  // Vendor admins can go to Orders
  if (
    role === EUserRole.Vendor_Admin ||
    role === EUserRole.Vendor_Super_Admin
  ) {
    return RoutePath.Orders
  }

  // Default fallback
  return RoutePath.Login
}
